export default __webpack_public_path__ + "static/media/Ballroll_00167.02f1dccd.png";